import { render, staticRenderFns } from "./scene4.vue?vue&type=template&id=b054d998&scoped=true&"
import script from "./scene4.vue?vue&type=script&lang=ts&"
export * from "./scene4.vue?vue&type=script&lang=ts&"
import style0 from "./scene4.vue?vue&type=style&index=0&id=b054d998&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b054d998",
  null
  
)

export default component.exports